import React from 'react';

import type { GradeScore } from '../../../../types/frapi-types.js';
import type { GradeComponent } from '../../../../../core/data-sources/content-components/types.js';

import Grade from './Grade.js';

interface InlineGradeProps {
  item: GradeComponent;
  groupIndex: number;
  isGuide: boolean;
}

const InlineGrade: React.FC<InlineGradeProps> = ({
  item,
  groupIndex,
  isGuide,
}) => {
  const showGrade = groupIndex >= 0 || isGuide;

  return showGrade ? (
    <div className="inline-grade">
      <Grade name="Vår vurdering:" value={(item.grade * 6) as GradeScore} />
    </div>
  ) : null;
};

export default InlineGrade;
